import { useLayoutEffect as e } from "react";
var a = e;
export {
  a as default
};
